import { CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { Text } from "../../../foundations/typography/Text";

type Props = {
  children: React.ReactNode;
  style?: CascadiaTypographyStyle;
  isSection?: boolean;
};

export function NavigationTitle(props: Props) {
  const { isSection, style, children } = props;
  return (
    <div
      className={css(titleStyles, {
        paddingLeft: isSection ? "var(--space-5)" : "var(--space-3)",
      })}
    >
      <Text style={style}>{children}</Text>
    </div>
  );
}
export const titleStyles = css({
  paddingRight: "var(--space-3)",
  display: "flex",
  alignItems: "center",
  height: "var(--space-10)",
});
